import { render, staticRenderFns } from "./Vulnerability.vue?vue&type=template&id=84c18528&scoped=true&"
import script from "./Vulnerability.vue?vue&type=script&lang=js&"
export * from "./Vulnerability.vue?vue&type=script&lang=js&"
import style0 from "./Vulnerability.vue?vue&type=style&index=0&id=84c18528&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c18528",
  null
  
)

export default component.exports